import type { MonospaceOrgRole } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const OrgRole = withItemType<MonospaceOrgRole>().defineCollection({
	name: 'MonospaceOrgRole',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'name', 'isAdmin'],
		endpoint: 'system/roles',
	},
});
